import { render, staticRenderFns } from "./budget-table.vue?vue&type=template&id=06f93d89&"
import script from "./budget-table.vue?vue&type=script&lang=js&"
export * from "./budget-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports